import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100" }
const _hoisted_2 = {
  id: "picadoSlider",
  class: "carousel slide bg-dark",
  "data-bs-ride": "carousel",
  "data-bs-touch": "true",
  "data-bs-pause": "false",
  "data-bs-interval": "4000",
  style: {"height":"100vh"}
}
const _hoisted_3 = {
  key: 0,
  class: "fa-2x d-flex justify-content-center align-items-center text-muted w-100 h-100 text-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "carousel-indicators" }
const _hoisted_7 = ["data-bs-slide-to", "aria-current", "aria-label"]
const _hoisted_8 = { class: "carousel-inner" }
const _hoisted_9 = { class: "slider-content text-center position-absolute m-auto text-light" }
const _hoisted_10 = { class: "fw-bold mb-3" }
const _hoisted_11 = ["href", "target"]
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#picadoSlider\" data-bs-slide=\"prev\"><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\"></span><span class=\"visually-hidden\">Previous</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#picadoSlider\" data-bs-slide=\"next\"><span class=\"carousel-control-next-icon\" aria-hidden=\"true\"></span><span class=\"visually-hidden\">Next</span></button>", 2)
const _hoisted_15 = {
  key: 0,
  class: "hompage-steps position-relative"
}
const _hoisted_16 = { class: "container container-fluid" }
const _hoisted_17 = { class: "row pt-5" }
const _hoisted_18 = {
  class: "col-md-4 position-relative",
  style: {"z-index":"100"}
}
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  src: "/images/mobile-steps.png"
}
const _hoisted_21 = { class: "col-md-8 pt-4" }
const _hoisted_22 = { class: "step mb-5" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h6", { class: "text-uppercase text-primary fw-bold" }, "Step 1", -1)
const _hoisted_24 = { class: "fw-bold" }
const _hoisted_25 = { class: "text-muted fw-normal" }
const _hoisted_26 = { class: "step mb-5" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h6", { class: "text-uppercase text-primary fw-bold" }, "Step 2", -1)
const _hoisted_28 = { class: "fw-bold" }
const _hoisted_29 = { class: "text-muted fw-normal" }
const _hoisted_30 = { class: "step mb-5" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h6", { class: "text-uppercase text-primary fw-bold" }, "Step 3", -1)
const _hoisted_32 = { class: "fw-bold" }
const _hoisted_33 = { class: "text-muted fw-normal" }
const _hoisted_34 = { class: "get-app-row primary-gradient-bg position-absolute start-0 w-100" }
const _hoisted_35 = { class: "container container-fluid" }
const _hoisted_36 = { class: "row py-4" }
const _hoisted_37 = { class: "offset-md-4 col-md-8" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h5", { class: "text-white mb-3" }, "Get the App", -1)
const _hoisted_39 = { class: "list-inline" }
const _hoisted_40 = { class: "list-inline-item" }
const _hoisted_41 = ["href"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/apple-store.png",
  height: "45"
}, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "list-inline-item" }
const _hoisted_45 = ["href"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/google-play.png",
  height: "45"
}, null, -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "featured-restaurants mb-5" }
const _hoisted_49 = { class: "container container-fluid" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between mb-4" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "main-section-title fw-bold" }, "Featured restaurants"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fw-bold mt-1 text-muted"
  }, " See all ")
], -1)
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "card shadow-sm rounded-3 border-0" }
const _hoisted_53 = ["src", "alt"]
const _hoisted_54 = { class: "card-body px-3" }
const _hoisted_55 = {
  key: 0,
  class: "text-success fw-bold small mb-1"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle availability" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Available")
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = {
  key: 1,
  class: "text-secondary fw-bold small mb-1"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle availability" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Not Available")
const _hoisted_62 = [
  _hoisted_60,
  _hoisted_61
]
const _hoisted_63 = { class: "card-title fw-bold mb-1" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Japanese Fusion", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn btn-primary rounded-3 w-100 fw-bold"
}, "Book Now", -1)
const _hoisted_66 = { class: "why-picado pb-5" }
const _hoisted_67 = { class: "container container-fluid" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between mb-4" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "main-section-title fw-bold" }, "Why Picado?")
], -1)
const _hoisted_69 = { class: "row d-flex align-items-center" }
const _hoisted_70 = { class: "col-md-6" }
const _hoisted_71 = ["src"]
const _hoisted_72 = {
  key: 1,
  src: "/images/why-picado.png",
  alt: "Why Picado?",
  class: "w-100"
}
const _hoisted_73 = ["innerHTML"]
const _hoisted_74 = /*#__PURE__*/_createStaticVNode("<section class=\"section-partners pb-5\"><div class=\"container container-fluid\"><div class=\"text-center mb-5\"><h4 class=\"fw-bold\">Our Partners</h4></div><div class=\"row pt-3\"><div id=\"partnerSlider\" class=\"carousel slide partnerSlider\" data-bs-ride=\"carousel\" data-bs-touch=\"true\" data-bs-pause=\"false\" data-bs-interval=\"4000\"><div class=\"carousel-inner\"><div class=\"carousel-item active position-relative\"><div class=\"slider-content row\"><div class=\"col-3 text-center\"><img src=\"/images/partners.png\"><p class=\"text-muted\">Partner Name</p></div><div class=\"col-3 text-center\"><img src=\"/images/partners.png\"><p class=\"text-muted\">Partner Name</p></div><div class=\"col-3 text-center\"><img src=\"/images/partners.png\"><p class=\"text-muted\">Partner Name</p></div><div class=\"col-3 text-center\"><img src=\"/images/partners.png\"><p class=\"text-muted\">Partner Name</p></div></div></div><div class=\"carousel-item\"><div class=\"slider-content row\"><div class=\"col-3 text-center\"><img src=\"/images/partners.png\"><p class=\"text-muted\">Partner Name</p></div><div class=\"col-3 text-center\"><img src=\"/images/partners.png\"><p class=\"text-muted\">Partner Name</p></div><div class=\"col-3 text-center\"><img src=\"/images/partners.png\"><p class=\"text-muted\">Partner Name</p></div><div class=\"col-3 text-center\"><img src=\"/images/partners.png\"><p class=\"text-muted\">Partner Name</p></div></div></div></div><button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#partnerSlider\" data-bs-slide=\"prev\"><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\"></span><span class=\"visually-hidden\">Previous</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#partnerSlider\" data-bs-slide=\"next\"><span class=\"carousel-control-next-icon\" aria-hidden=\"true\"></span><span class=\"visually-hidden\">Next</span></button></div></div></div></section>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.gallery || _ctx.gallery.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", null, [
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gallery, (item, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: item.id,
              type: "button",
              "data-bs-target": "#picadoSlider",
              "data-bs-slide-to": index,
              class: _normalizeClass(index == 0 ? 'active' : ''),
              "aria-current": index == 0 ? 'true' : '',
              "aria-label": item.tag_line
            }, null, 10, _hoisted_7))
          }), 128))
        ], 512), [
          [_vShow, _ctx.gallery && _ctx.gallery.length > 1]
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gallery, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass(["carousel-item position-relative", index == 0 ? 'active' : ''])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h1", _hoisted_10, _toDisplayString(item.tag_line), 1),
                _createElementVNode("a", {
                  href: item.call_to_action_url,
                  class: "btn btn-outline-primary rounded-5 btn-sm px-4 me-2 border-2 fw-bold",
                  target: item.open_as_new_page ? '_blank' : ''
                }, _toDisplayString(item.call_to_action_text), 9, _hoisted_11)
              ]),
              _createElementVNode("img", {
                src: item.image,
                class: "d-block",
                alt: item.tag_line
              }, null, 8, _hoisted_12)
            ], 2))
          }), 128))
        ]),
        (_ctx.gallery && _ctx.gallery.length > 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_13
            ], 64))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, _ctx.gallery]
      ])
    ]),
    (_ctx.other_content)
      ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                (_ctx.other_content.steps_app_screenshot)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.other_content.steps_app_screenshot
                    }, null, 8, _hoisted_19))
                  : (_openBlock(), _createElementBlock("img", _hoisted_20))
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("h5", _hoisted_24, _toDisplayString(_ctx.other_content.steps_step1_title), 1),
                  _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.other_content.steps_steps_step1_text), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("h5", _hoisted_28, _toDisplayString(_ctx.other_content.steps_step2_title), 1),
                  _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.other_content.steps_step2_text), 1)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("h5", _hoisted_32, _toDisplayString(_ctx.other_content.steps_step3_title), 1),
                  _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.other_content.steps_step3_text), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("ul", _hoisted_39, [
                    _createElementVNode("li", _hoisted_40, [
                      _createElementVNode("a", {
                        href: _ctx.$store.state.configuration.ios_link,
                        class: "me-2",
                        target: "_blank"
                      }, _hoisted_43, 8, _hoisted_41)
                    ]),
                    _createElementVNode("li", _hoisted_44, [
                      _createElementVNode("a", {
                        href: _ctx.$store.state.configuration.android_link,
                        class: "me-3",
                        target: "_blank"
                      }, _hoisted_47, 8, _hoisted_45)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_48, [
      _createElementVNode("div", _hoisted_49, [
        _hoisted_50,
        _createElementVNode("div", _hoisted_51, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.featured_restaurants, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-lg-3 col-md-4 col-sm-6",
              key: item.id
            }, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("img", {
                  src: item.featured_photo_thumbnails.cover_small,
                  class: "card-img-top",
                  alt: item.name
                }, null, 8, _hoisted_53),
                _createElementVNode("div", _hoisted_54, [
                  (item.availabity_status == 'A')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_55, _hoisted_58))
                    : (_openBlock(), _createElementBlock("p", _hoisted_59, _hoisted_62)),
                  _createElementVNode("h6", _hoisted_63, _toDisplayString(item.name), 1),
                  _hoisted_64,
                  _hoisted_65
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_66, [
      _createElementVNode("div", _hoisted_67, [
        _hoisted_68,
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            (_ctx.other_content && _ctx.other_content.why_image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.other_content.why_image,
                  alt: "Why Picado?",
                  class: "w-100"
                }, null, 8, _hoisted_71))
              : (_openBlock(), _createElementBlock("img", _hoisted_72))
          ]),
          (_ctx.other_content)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-md-6",
                innerHTML: _ctx.other_content.why_text
              }, null, 8, _hoisted_73))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_74,
    _createVNode(_component_Footer)
  ]))
}